<template>
  <router-view />
</template>

<script>
export default {
  name: 'AddressBookLayout'
}
</script>

<style scoped>
</style>
